import MarkingActivity from "./controllers/MarkingActivity";

let beginBtn;
let decodingData;
let defaultWidth = 1366;
let defaultHeight = 768;
let iOS;
let isHD = false;
let markingActivity;
let selectedGrade;
let stage;

document.addEventListener('DOMContentLoaded', function () {
    beginBtn = document.getElementById("beginBtn");
    beginBtn.addEventListener("click", beginInteraction);
    iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    defaultWidth = 1366;
    defaultHeight = 768;
    if(window.innerWidth > defaultWidth && window.innerHeight > defaultHeight)
    {
        isHD = true;
    }
    populateDecodingData();
});

function beginInteraction()
{
    window.addEventListener('resize', handleResize, false);
    selectedGrade = parseInt(document.getElementById("grades").value);
    document.getElementById("grade-selection-container").classList.add("hidden");
    document.getElementById("main-container").classList.remove("hidden");
    document.getElementById("canvas-container").classList.remove("hidden");
    document.getElementById("main-container").classList.add("bg-black");
    document.getElementById("main-container").classList.remove("bg-white")
    createActivity();
    resize();
}

function createActivity()
{
    markingActivity = new MarkingActivity();
    markingActivity.words = decodingData[selectedGrade].words;
    markingActivity.codes = decodingData[selectedGrade].codes;
    markingActivity.create();
    stage = markingActivity.getStage();
}

function handleResize()
{
    resize();
}

function populateDecodingData()
{
    decodingData = [];
    decodingData.push({grade: "K", words:["electric", "funny", "zebra"],
        codes:["1x,3x,5b,7x,0[,1],1l,1[,4],3s,7s", "2x,5x,0[,3],3|,2s,5f", "2x,3b,5x,0[,2],2l,5s"]});
    decodingData.push({grade: "1", words:["electric", "funny", "zebra"],
        codes:["1x,3x,5b,7x,0[,1],1l,1[,4],3s,7s", "2x,5x,0[,3],3|,2s,5f", "2x,3b,5x,0[,2],2l,5s"]});
    decodingData.push({grade: "2", words:["electric", "funny", "zebra"],
        codes:["1x,3x,5b,7x,0[,1],1l,1[,4],3s,7s", "2x,5x,0[,3],3|,2s,5f", "2x,3b,5x,0[,2],2l,5s"]});
}

function resize()
{
    let curWindowWidth = screen.width < window.innerWidth ? screen.width : window.innerWidth;
    let curWindowHeight = screen.height < window.innerHeight ? screen.height : window.innerHeight;
    //let desiredWidth = (isHD) ? defaultWidth*2 : defaultWidth;
    //let desiredHeight = (isHD) ? defaultHeight*2 : defaultHeight;
    let desiredWidth = defaultWidth;
    let desiredHeight = defaultHeight;
    let headerAndFooterHeightTotal = 0;
    let padding = 0;
    let targetHeight;
    let targetScale;
    let targetWidth;
    let usableHeight = curWindowHeight - headerAndFooterHeightTotal - padding;
    let usableWidth = curWindowWidth - padding;

    targetScale = usableWidth / desiredWidth;
    if(targetScale > 1)
    {
        targetScale = 1;
    }
    if(targetScale <= 0)
    {
        targetScale = .001;
    }
    stage.scale.set(targetScale);

    targetHeight = desiredHeight * targetScale;
    if(targetHeight > usableHeight)
    {
        targetScale = usableHeight / desiredHeight;
    }

    if(targetScale > 1)
    {
        targetScale = 1;
    }
    if(targetScale <= 0)
    {
        targetScale = .001;
    }
    targetWidth = desiredWidth * targetScale;
    targetHeight = desiredHeight * targetScale;
    document.getElementById("pixi-canvas").setAttribute("width", targetWidth);
    document.getElementById("pixi-canvas").setAttribute("height", targetHeight);
    stage.scale.set(targetScale);
}
